import { parseData, post } from './common';
const createNewCredentials = (SFTPCredentials) => {
    return post('/InternalAPI/FTPTodayAPI.asmx/CreateNewCredentials', {
        SFTPCredentials
    }).then(parseData);
};
const getCredentialsByHomeFolder = (Path) => {
    return post('/InternalAPI/FTPTodayAPI.asmx/GetCredentialsByHomeFolder', {
        Path
    }).then(parseData);
};
const createFolder = (Path, Comment) => {
    return post('/InternalAPI/FTPTodayAPI.asmx/CreateFolder', {
        Path,
        Comment
    }).then(parseData);
};
const getFolderByPath = (Path) => {
    return post('/InternalAPI/FTPTodayAPI.asmx/GetFolderByPath', {
        Path
    }).then(parseData);
};
export { createNewCredentials, getCredentialsByHomeFolder, getFolderByPath, createFolder };
